import React from "react";
import { Link } from "react-router-dom";
import { BiSolidChevronRight } from "react-icons/bi";
import { IoIosCall } from "react-icons/io";
import logo from "../assets/nav_logo.png";
import { prductData } from "../Data";

const Footer = ({ openDemo }) => {
  return (
    <>
      {/* cta */}
      <div className="py-8 md:py-12 bg-blue-50 border-t border-b border-blue-100 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: "radial-gradient(#CBD5E1 1px, transparent 1px)",
            backgroundSize: "24px 24px",
          }}
        />
        <div className="max-w-7xl mx-auto px-5 lg:px-8 relative z-10 text-center">
          <div className="flex flex-col md:flex-row items-center justify-between gap-5">
            <div className="w-full md:w-3/4 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-teko uppercase tracking-wide text-blue-800 mb-1">
                Our Unique Technological Solutions
              </h2>
              <p className="text-sm md:text-lg text-slate-600 font-medium">
                We transform your business by offering automations that are reliable, innovative, and creative.
              </p>
            </div>
            <div className="w-full md:w-1/4 flex justify-center md:justify-end">
              <button
                onClick={openDemo}
                className="px-6 md:px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded font-medium shadow-md hover:-translate-y-1 transition-all duration-300 text-sm"
              >
                Request a Demo
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* footer */}
      <footer className="bg-white text-slate-600 relative">
        <div className="mx-auto w-full max-w-7xl px-5 lg:px-8 py-10 md:py-16">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">

            {/* info */}
            <div className="md:col-span-2 lg:col-span-1">
              <Link to="/" className="mb-4 flex justify-center lg:justify-center">
                <img
                  src={logo}
                  className="h-14 object-contain"
                  alt="BFI Infotech Logo"
                />
              </Link>
              <div className="space-y-3 text-sm font-medium">
                <p className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="mr-3 min-w-[18px] h-5 w-5 mt-0.5 text-blue-600 flex-shrink-0"
                  >
                    <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                    <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                  </svg>
                  <span className="leading-relaxed text-xs md:text-sm">
                    Flat No - 706, B-wing Sai Vihar Chs.
                    <br />Near Amity International School
                    <br />Sector 15 CBD Belapur, Navi Mumbai
                    <br />400614, Maharashtra, INDIA.
                  </span>
                </p>
                <p className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="mr-3 h-5 w-5 text-blue-600 flex-shrink-0"
                  >
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                  </svg>
                  <a
                    href="mailto:info@bfiinfotech.co.in"
                    className="hover:text-blue-600 transition-colors text-xs md:text-sm break-all"
                  >
                    info@bfiinfotech.co.in
                  </a>
                </p>
                <p className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="mr-3 h-5 w-5 text-blue-600 flex-shrink-0"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <a
                    href="tel:+919769847865"
                    className="hover:text-blue-600 transition-colors text-xs md:text-sm"
                  >
                    +91 9769847865
                  </a>
                </p>
              </div>
            </div>

            {/* links */}
            <div className="grid grid-cols-2 gap-6 md:grid-cols-1 md:gap-0 lg:contents">

              {/* quick links */}
              <div>
                <h2 className="mb-4 text-base md:text-xl font-bold text-slate-800 uppercase border-b-2 border-blue-100 pb-2 inline-block">
                  Quick Links
                </h2>
                <ul className="text-slate-600 font-medium space-y-2 md:space-y-3">
                  {["About", "Service", "Product", "Contact"].map((item, idx) => (
                    <li key={idx} className="flex items-center group">
                      <BiSolidChevronRight className="text-blue-600 mr-1 transform group-hover:translate-x-1 transition-transform flex-shrink-0" />
                      <Link
                        to={`/${item.toLowerCase()}`}
                        className="hover:text-blue-700 transition-colors text-xs md:text-sm"
                      >
                        {item}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* services */}
              <div>
                <h2 className="mb-4 text-base md:text-xl font-bold text-slate-800 uppercase border-b-2 border-blue-100 pb-2 inline-block">
                  Services
                </h2>
                <ul className="text-slate-600 font-medium space-y-2 md:space-y-3">
                  {[
                    "Custom Software",
                    "App Development",
                    "E-Commerce",
                    "Consulting",
                    "Cyber Security",
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-center group">
                      <BiSolidChevronRight className="text-blue-600 mr-1 transform group-hover:translate-x-1 transition-transform flex-shrink-0" />
                      <Link
                        to="/service"
                        className="hover:text-blue-700 transition-colors text-xs md:text-sm"
                      >
                        {item}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* products */}
            <div className="md:col-span-2 lg:col-span-1">
              <h2 className="mb-4 text-base md:text-xl font-bold text-slate-800 uppercase border-b-2 border-blue-100 pb-2 inline-block">
                Products
              </h2>
              <ul className="text-slate-600 font-medium space-y-2 md:space-y-3">
                {prductData.slice(0, 6).map((product) => (
                  <li key={product.id} className="flex items-center group">
                    <BiSolidChevronRight className="text-blue-600 mr-1 transform group-hover:translate-x-1 transition-transform flex-shrink-0" />
                    <Link
                      to={`/product/${product.id}`}
                      className="hover:text-blue-700 transition-colors truncate max-w-[200px] text-xs md:text-sm"
                    >
                      {product.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* copyright */}
        <div className="bg-slate-50 border-t border-slate-200">
          <div className="mx-auto w-full max-w-7xl px-5 lg:px-8 py-4 md:py-6">
            <div className="flex justify-center items-center gap-1.5 sm:gap-4 text-[9px] sm:text-[11px] md:text-sm text-slate-500 text-center whitespace-nowrap">
              <a href="tel:+919769847865" className="flex items-center gap-1 hover:text-blue-600 transition-colors">
                <IoIosCall className="text-[10px] sm:text-xs md:text-sm" /> Pravin Kashid
              </a>
              <span className="text-slate-300">•</span>
              <span className="hidden sm:inline">
                Copyright © 2018 - 2026 <b className="text-slate-700">All Right Reserved By BFI</b>
              </span>
              <span className="sm:hidden">
                © 2018-26 <b className="text-slate-700">All Right Reserved By BFI</b>
              </span>
              <span className="text-slate-300">•</span>
              <a
                href="mailto:Info@bfiinfotech.co.in"
                className="hover:text-blue-600 transition-colors "
              >
                info@bfiinfotech.co.in
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
